const Z = 3.291;
export const confidenceInterval = (values: number[], mean: number): [number, number] => {
  const n = values.length;
  if (n === 1) {
    return [mean, mean];
  } else {
    const v =
      values.reduce((a, x) => {
        return a + Math.pow(x - mean, 2);
      }, 0) /
      (n - 1);
    const e = Math.sqrt(v) / Math.sqrt(n);
    const i = e * Z;
    return [mean - i, mean + i];
  }
};
